webpackJsonp([8],{

/***/ 108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Styles_common_less__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Styles_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Styles_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_card_card_less__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_card_card_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_Components_card_card_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_info_number_info_number_less__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_info_number_info_number_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_Components_info_number_info_number_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_quote_quote_less__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_quote_quote_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_Components_quote_quote_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_partners_list_partners_list_less__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_partners_list_partners_list_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_Components_partners_list_partners_list_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_section_header_section_header_less__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_section_header_section_header_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_Components_section_header_section_header_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_WebComponents_tabs_tabs_less__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_WebComponents_tabs_tabs_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_WebComponents_tabs_tabs_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apply_apply_less__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apply_apply_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__apply_apply_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__feedback_feedback_less__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__feedback_feedback_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__feedback_feedback_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__news_news_less__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__news_news_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__news_news_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__promo_promo_less__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__promo_promo_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__promo_promo_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_WebComponents_greedy_nav__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__slider__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_WebComponents_a11y__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_promise__);














//import 'babel-polyfill';


//import 'WebComponents/adaptive-background';


//const mapContext = require('bundle-loader?lazy&name=russia-map!!svg-inline-loader!Images/russia-map.svg');

var a11y = new __WEBPACK_IMPORTED_MODULE_13_WebComponents_a11y__["a" /* A11y */]();
a11y.init();

if (!window.Promise) {
  window.Promise = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_promise___default.a;
}

var componentContext = [__webpack_require__(91)];

var symbolsContext = [__webpack_require__(90)];
document.addEventListener("DOMContentLoaded", function () {
  !true && document.body.classList.add('is-debug');
  componentContext.forEach(function (context) {
    context(function () {});
  });
});

// TODO: replace onload to scroll to container event
window.addEventListener("load", function () {
  symbolsContext.forEach(function (context) {
    context(function () {});
  });
  /*mapContext((file) => {});*/
});

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

var cbs = [], 
	data;
module.exports = function(cb) {
	if(cbs) cbs.push(cb);
	else cb(data);
}
__webpack_require__.e/* require.ensure */(1).then((function(require) {
	data = __webpack_require__(115);
	var callbacks = cbs;
	cbs = null;
	for(var i = 0, l = callbacks.length; i < l; i++) {
		callbacks[i](data);
	}
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_src_less_swiper_less__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_src_less_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_src_less_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider_less__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slider_less__);
/* eslint no-unused-vars: "off" */



window.addEventListener('load', function () {
  var swiperContext = __webpack_require__(41);

  swiperContext(function (Swiper) {
    var mainSlider = new Swiper('.swiper-container.c-main-slider__container', {
      loop: true,
      autoplay:  true ? 7000 : '',
      effect: 'fade',
      simulateTouch: false,
      preloadImages: false,
      lazyLoading: true,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev'
    });
  });
});

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(4).then((function(require) {
		cb(__webpack_require__(213));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(0).then((function(require) {
		cb(__webpack_require__(116));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[119]);


// WEBPACK FOOTER //
// home.js